import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import UserDisplay from './UserDisplay'
import UserDropdown from './UserDropdown'
import redirect from '../../lib/redirect'
import { logOut } from '../../store/actions'
import { Button } from '@minted/minted-components'

const UserMenuContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: center;
  margin-right: 25px;
  min-width: 150px;
  max-width: 147px;
  max-height: 48px;
  &:hover {
    cursor: pointer;
  }
`

class UserMenu extends Component {
  state = {
    open: false,
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick, false)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false)
  }

  toggleOpen = () => {
    this.setState(prevState => ({
      open: !prevState.open,
    }))
  }

  handleClick = e => {
    if (!this.containerRef.current) {
      return
    }

    if (!this.containerRef.current.contains(e.target)) {
      this.setState(() => ({ open: false }))
    }
  }

  containerRef = React.createRef()

  render() {
    return this.props.isAuthenticated ? (
      <UserMenuContainer ref={this.containerRef}>
        <UserDisplay
          toggleOpen={this.toggleOpen}
          userName={this.props.name}
          userPicture={this.props.picture}
          isAuthenticated={this.props.isAuthenticated}
        />
        <UserDropdown
          open={this.state.open}
          logOut={() => {
            this.props.dispatch(logOut())
          }}
        />
      </UserMenuContainer>
    ) : null
  }
}

function mapStateToProps(state, ownProps) {
  return {
    ...state.user,
    ...ownProps,
  }
}

export default connect(mapStateToProps)(UserMenu)
